import React, { cloneElement } from "react";
import { Provider } from "react-redux";
import { Route, Navigate, Routes, Outlet, useLocation } from "react-router-dom";
import {
  store,
  persistor,
} from "./configurations/redux-configurations/config/store";
import { PersistGate } from "redux-persist/integration/react";
import PrivateRoute from "./components/PrivateRoute";
import NetworkDetector from "./components/common/NetworkDetector";
import PageNotFound from "./components/common/PageNotFound";
import FarmerHeader from "./components/common/FarmerHeader";

//Farmer element imports
import Register from "./components/registration/Register";
import Login from "./components/login/Login";
import UserProfile from "./components/profile/UserProfile";
import Dashboard from "./components/dashboard/Dashboard";
import RegisterMap from "./components/registrationMap/RegisterMap";
import WDPMap from "./components/wdpMap/WDPMap";
import ConsentPopup from "./components/dashboard/ConsentPopup";

//Staff element imports
import StaffHeader from "./components/common/StaffHeader";
import StaffWellForm from "./components/staff/wellForm/StaffWellForm";
import StaffWellReport from "./components/staff/StaffWellReport";
import WellConnectionReport from "./components/staff/wellConnectionReport/WellConnectionReport";
import StaffAsFarmerLogin from "./components/staff/login/StaffAsFarmerLogin";
import FarmerSession from "./components/staff/login/FarmerSession";
import MultipleFieldCrops from "./components/crops/MultipleFieldCrops";
import StaffUserNotes from "./components/staff/StaffUserNotes";
import FieldWellCropReport from "./components/staff/FieldWellCropReport";
import SeasonalAverages from "./components/seasonalAverages/SeasonalAverages";
import FieldTransfer from "./components/staff/FieldTransfer";
import WellChemigationReport from "./components/staff/WellChemigationReport";
import FarmerFooter from "./components/common/FarmerFooter";
import PumpRatesReport from "./components/pumpRates/PumpRatesReport";

const HeaderFooterLayout = ({ header, footer }) => {
  const location = useLocation();
  return (
    <>
      {cloneElement(header, { currentPath: location.pathname })}
      <Outlet />
      {footer && <FarmerFooter />}
    </>
  );
};
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <NetworkDetector />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <HeaderFooterLayout header={<FarmerHeader />} footer={true} />
            }
          >
            <Route path="/register" element={<Register />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Navigate to="/map" replace />} />
            <Route
              element={
                <HeaderFooterLayout header={<FarmerHeader />} footer={true} />
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<UserProfile />} />
              <Route path="/crops" element={<MultipleFieldCrops />} />
              <Route path="/seasonal-averages" element={<SeasonalAverages />} />
            </Route>
            <Route
              element={
                <HeaderFooterLayout header={<FarmerHeader />} footer={false} />
              }
            >
              <Route path="/map" element={<RegisterMap />} />
              <Route path="/farmer" element={<WDPMap />} />
              <Route path="/pump-rates" element={<PumpRatesReport />} />
            </Route>
          </Route>

          {/* Staff Routes */}
          <Route path="/req" element={<FarmerSession />} />
          <Route
            element={
              <HeaderFooterLayout header={<StaffHeader />} footer={true} />
            }
          >
            <Route path="/well-test-form" element={<StaffWellForm />} />
          </Route>
          <Route element={<PrivateRoute isStaffRoute={true} />}>
            <Route
              element={
                <HeaderFooterLayout header={<StaffHeader />} footer={true} />
              }
            >
              <Route path="/well-test-report" element={<StaffWellReport />} />
              <Route
                path="/well-chemigation-report"
                element={<WellChemigationReport />}
              />
              <Route
                path="/well-connection-report"
                element={<WellConnectionReport />}
              />
              <Route
                path="/field-well-crop-report"
                element={<FieldWellCropReport />}
              />
              <Route
                path="/staff-as-farmer-login"
                element={<StaffAsFarmerLogin />}
              />
              <Route path="/field-transfer" element={<FieldTransfer />} />
            </Route>
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </PersistGate>
    </Provider>
  );
}

export default App;
